import { cn } from '@/utils/tailwind-merge';

const H3 = ({ text, className }: { text: string; className?: string }) => {
    return <span className={cn('text-[86px] leading-[86px] font-bold', className)}>{text}</span>;
};

export default H3;
